import { z } from 'zod'

export const GetCurrencyCodeSchema = z.enum(['EUR', 'USD', 'GBP', 'PLN'])

export const GetCurrencySchema = z.object({
  alias: z.enum(['eur', 'gbp', 'pln', 'usd']),
  iso_code: z.string(),
  symbol: z.string(),
  title: z.string(),
})
